export default __webpack_public_path__ + "static/media/file.6a8ca5b7.svg";